import React from "react";

import '../../styles/global/ButtonStyles.css';

const CoachingParaEmpresas = () => {
  return (
    <section className="section-container">
      <h2>Coaching para Empresas</h2>
      <h3>Impulsa el Éxito de Tu Empresa con Coaching Ontológico</h3>
      <p>
        En un entorno empresarial cada vez más dinámico, el éxito depende de la capacidad de las personas para adaptarse, crecer y colaborar de manera efectiva. Las sesiones de Coaching Ontológico para empresas están diseñadas para transformar el potencial de tus equipos y lograr resultados sobresalientes, alineados con los valores y objetivos de tu organización.
      </p>

      <div className="tipos-eneagrama-container">
        <h4>¿Qué es el Coaching Ontológico para empresas?</h4>
        <p>
          El Coaching Ontológico para empresas va más allá de las soluciones superficiales. Trabajamos con los líderes y equipos para transformar la manera en que piensan, sienten y actúan dentro de la organización. Este enfoque integral mejora el liderazgo, la comunicación, la colaboración y la toma de decisiones, ayudando a las empresas a adaptarse a los desafíos y aprovechar las oportunidades.
        </p>
      </div>

      <div className="tipos-eneagrama-container">
        <h4>¿Por qué implementar Coaching Ontológico en tu empresa?</h4>
        <ul>
          <li>• Mejora del liderazgo: líderes más conscientes de sus decisiones, capaces de inspirar y dirigir a sus equipos con propósito y claridad.</li>
          <li>• Alineación organizacional: todos los miembros de tu equipo trabajarán con objetivos alineados, mejorando la productividad y reduciendo conflictos.</li>
          <li>• Optimización de la comunicación: fomentamos una comunicación abierta y efectiva que refuerza la cooperación y la confianza dentro del equipo.</li>
          <li>• Gestión del cambio: ayudamos a las empresas a adaptarse al cambio organizacional, mejorando la resiliencia y la flexibilidad ante nuevos desafíos.</li>
        </ul>
      </div>

      <div className="tipos-eneagrama-container">
        <h4>Beneficios para tu empresa:</h4>
        <ul>
          <li>• Mayor rendimiento: equipos alineados y motivados logran resultados más rápidos y sostenibles.</li>
          <li>• Mejor toma de decisiones: líderes y empleados más conscientes de sus opciones y de las consecuencias de sus elecciones.</li>
          <li>• Cultura empresarial más fuerte: se fomenta una cultura de trabajo positiva, ética y colaborativa.</li>
          <li>• Desarrollo de habilidades emocionales y cognitivas: ayudamos a entender las motivaciones de los individuos, mejorando las relaciones interpersonales y el clima laboral.</li>
        </ul>
      </div>

      <div className="tipos-eneagrama-container">
        <h4>¿Cómo funciona el Coaching Ontológico para empresas?</h4>
        <p>
          Ofrecemos programas personalizados que incluyen:
        </p>
        <ul>
          <li>• Sesiones de Coaching individual para líderes y mandos intermedios: Para mejorar su capacidad de liderazgo, comunicación y toma de decisiones.</li>
          <li>• Talleres grupales: Para fomentar la colaboración, resolver conflictos y mejorar las dinámicas de trabajo en equipo.</li>
          <li>• Programas a medida para objetivos específicos: Diseñados para abordar áreas clave como la innovación, gestión del cambio o la integración de nuevas estrategias organizacionales.</li>
        </ul>
      </div>

      <div className="tipos-eneagrama-container">
        <h4>Lo que lograrás con nuestras sesiones de Coaching Ontológico:</h4>
        <ul>
          <li>• Equipos más comprometidos, productivos y alineados con los objetivos de la empresa.</li>
          <li>• Líderes con mayor claridad en su visión y estrategias, capaces de impulsar el cambio de manera efectiva.</li>
          <li>• Un entorno de trabajo más armonioso, donde la comunicación fluye de manera abierta y sin barreras.</li>
        </ul>
      </div>

      <h3>Precios:</h3>
      <div className="price-container">
        <div className="tipos-eneagrama-container price-card">
          <h4>Sesión individual de Coaching para ejecutivos (1 hora):</h4>
          <p>60€</p>
        </div>
        <div className="tipos-eneagrama-container price-card">
          <h4>Talleres para equipos (por hora):</h4>
          <p>40€</p>
        </div>
        <div className="tipos-eneagrama-container price-card">
          <h4>Paquete de Coaching para empresas (10 sesiones para líderes y equipos):</h4>
          <p>500€ (ahorro de 100€)</p>
        </div>
      </div>

      <h3>Empieza a transformar tu organización hoy mismo</h3>
      <p>
        El Coaching Ontológico puede ser la clave para que tu empresa alcance su máximo potencial. Con un enfoque personalizado, ayudamos a tus equipos a tomar decisiones más acertadas, gestionar el cambio de manera efectiva y trabajar con mayor compromiso y alineación.
      </p>
      <p>
        <b>Reserva ahora una consulta inicial</b> y descubre cómo podemos ayudar a tu empresa a alcanzar nuevas alturas.
      </p>

      <button
            className="btn-contacto"
            onClick={() => {
                window.open(
                "https://wa.me/34696667110?text=Hola. Quiero información de Coaching para empresas.",
                "_blank"
                );
            }}
            >
            Consulta una sesión gratuita
            </button>
    </section>
  );
};

export default CoachingParaEmpresas;
